import React from "react";
import { Col, Row } from "antd";
import { ContactInfo } from "../ContactInfo";
import styles from "./contactSection.scss";

const section = {
  needHelp: "need-help",
  workingHours: "working-hours",
  email: 'email'
}

const ContactSection = ({ className }) => (
  <Row className={className}>
    <Col xs={24} sm={24} md={12} lg={14} xl={14}>
      <ContactInfo
        id={section.workingHours}
        value={(
          <React.Fragment>
            <span style={{ display: "block" }}>Ponedjeljak – petak:</span>
            <span style={{ display: "block" }}>od 8 do 16 h</span>
            <span style={{ display: "block" }}>Vikendi, blagdani i praznici:</span>
            <span style={{ display: "block" }}>neradno</span>
          </React.Fragment>)}
        title={"Radno vrijeme korisničke podrške"}
      />
    </Col>

    <Col xs={24} sm={24} md={12} lg={24} xl={24}>
      <a href="mailto:oglasi@index.hr">
        <ContactInfo
          id={section.email}
          value="oglasi@index.hr"
          title={"E-mail"}
          clickable
        />
      </a>
    </Col>

    <Col xs={24} sm={24} md={12} lg={12} xl={12}>
      <ContactInfo
        id={section.needHelp}
        title={"Korisnička podrška"}
        value="091/6089171"
      />

    </Col>
  </Row>
);

export default ContactSection;



// WEBPACK FOOTER //
// ./src/components/Footer/ContactSection/ContactSection.tsx